









































import { defineComponent, PropType } from "@vue/composition-api"
import ButtonLinkAtom from "@/shared/components/atoms/card/ButtonLinkAtom.vue"
import { IStudy } from "@/shared/models/api/study-choice-studies-model"
import { Config } from "@/apps/MyStudyChoiceFavoritesWidget/models/config-viewmodel"
import { useActions } from "vuex-composition-helpers"

export default defineComponent({
    name: "StudyItem",
    components: { ButtonLinkAtom },
    props: {
        study: {
            type: Object as PropType<IStudy>,
            required: true,
            default: () => { }
        },
        config: {
            type: Object as PropType<Config>,
            required: true,
            default: () => { }
        }
    },
    setup: (props) => {

        const { addStudyChoiceFavorite } = useActions(['addStudyChoiceFavorite']);
        const addFavoriteStudy = async (studyCode: string) => {
            await addStudyChoiceFavorite(studyCode);
        }

        return { addFavoriteStudy }
    }
})
